import n from "tonweb";
const {
  HttpProvider: a,
  Address: o,
  token: {
    jetton: { JettonMinter: r }
  }
} = n;
class A {
  constructor(t) {
    this.tonApiProvider = t;
  }
  async getJettonWalletAddress({
    jettonAddress: t,
    ownerAddress: e
  }) {
    return (await new r(
      this.tonApiProvider,
      // @ts-expect-error - not all parameters are really required here
      {
        address: t
      }
    ).getJettonWalletAddress(
      new o(e)
    )).toString();
  }
}
export {
  A as StonApiClient
};
//# sourceMappingURL=StonApiClient.js.map
